import React from "react";
import Spinner from "react-bootstrap/Spinner";

export default function LoadingComponent() {
  return (
    <Spinner
      animation="border"
      variant="primary"
      style={{
        width: 40,
        height: 40,
        borderWidth: 6,
      }}
    />
  );
}
